<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        Блокировка заказов
        <v-spacer />
        <v-text-field
          v-model="manualOrderId"
          label="№ заказа"
          type="number"
          dense
          hide-details
          style="max-width: 150px"
          class="mr-2"
        />
        <v-btn color="primary" :disabled="!manualOrderId" @click="blockManually">
          Заблокировать
        </v-btn>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="blockedOrders"
        :loading="isLoading"
        :items-per-page="50"
        loading-text="Загрузка..."
        no-data-text="Заблокированных заказов нет"
      >
        <template v-slot:[`item.orderCreatedDate`]="{ item }">
          {{ formatDate(item.orderCreatedDate) }}
        </template>
        <template v-slot:[`item.blockedDate`]="{ item }">
          {{ formatDate(item.blockedDate) }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn small color="success" class="mr-2" @click="openAccept(item)">
            Принять
          </v-btn>
          <v-btn small color="error" @click="openUnblock(item)">
            Разблокировать
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="acceptDialog" max-width="420">
      <v-card>
        <v-card-title>Принять заказ №{{ selected && selected.orderId }}</v-card-title>
        <v-card-text>
          Заказ будет отмечен как отправленный дистрибьютору.
          <v-menu v-model="dateMenu" :close-on-content-click="false" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="acceptDate"
                label="Дата заказа"
                readonly
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker v-model="acceptDate" @input="dateMenu = false" />
          </v-menu>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="acceptDialog = false">Отмена</v-btn>
          <v-btn color="success" @click="confirmAccept">Принять</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="unblockDialog" max-width="420">
      <v-card>
        <v-card-title>Разблокировать заказ №{{ selected && selected.orderId }}</v-card-title>
        <v-card-text>
          Аптека снова сможет изменять и отправлять этот заказ. Убедитесь, что заказ НЕ дошёл до дистрибьютора.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="unblockDialog = false">Отмена</v-btn>
          <v-btn color="error" @click="confirmUnblock">Разблокировать</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'BlockedOrders',
  data() {
    return {
      manualOrderId: null,
      selected: null,
      acceptDialog: false,
      unblockDialog: false,
      dateMenu: false,
      acceptDate: new Date().toISOString().substr(0, 10),
      headers: [
        { text: '№ заказа', value: 'orderId' },
        { text: 'Логин', value: 'userLogin' },
        { text: 'Аптека', value: 'pharmacyName' },
        { text: 'БИН', value: 'bin' },
        { text: 'Дистрибьютор', value: 'filialName' },
        { text: 'Дата заказа', value: 'orderCreatedDate' },
        { text: 'Дата блокировки', value: 'blockedDate' },
        { text: 'Действия', value: 'actions', sortable: false }
      ]
    }
  },
  computed: {
    ...mapState('blockedOrder', ['blockedOrders', 'isLoading'])
  },
  created() {
    this.fetchBlockedOrders()
  },
  methods: {
    ...mapActions('blockedOrder', ['fetchBlockedOrders', 'acceptOrder', 'unblockOrder', 'blockOrder']),
    formatDate(value) {
      if (!value) return '—'
      return new Date(value).toLocaleString('ru-RU')
    },
    openAccept(item) {
      this.selected = item
      this.acceptDialog = true
    },
    openUnblock(item) {
      this.selected = item
      this.unblockDialog = true
    },
    async confirmAccept() {
      await this.acceptOrder({ orderId: this.selected.orderId, orderDate: this.acceptDate })
      this.acceptDialog = false
    },
    async confirmUnblock() {
      await this.unblockOrder(this.selected.orderId)
      this.unblockDialog = false
    },
    async blockManually() {
      await this.blockOrder(Number(this.manualOrderId))
      this.manualOrderId = null
    }
  }
}
</script>
